'use client';

import Image, { StaticImageData } from 'next/image';

import { HeadingTwo } from '@/components/Typography/Heading';
import Paragraph from '@/components/Typography/Paragraph';

interface SectionDalmatianProps {
  title: string;
  description: string;
  image: StaticImageData;
}

const SectionDalmatian = ({ title, description, image }: SectionDalmatianProps) => {
  return (
    <div className="relative mx-auto max-w-[62.75rem] px-[30px] sm:py-[100px] sm:pt-0 sm:pb-[109px] md:pb-[75px] md:pt-0 lg:px-0 lg:pt-0">
      <div className="grid sm:mx-auto sm:grid-cols-1 md:grid-cols-2 lg:-mx-[15px]">
        <div className="lg:pl-[15px] lg:pr-[46px]">
          <HeadingTwo variant="primary" className="font-circular-std-medium sm:mb-[37px] lg:mb-6">
            {title}
          </HeadingTwo>
          <Paragraph variant="light-gray" className="mb-4">
            {description}
          </Paragraph>
        </div>

        <Image
          src={image}
          loading="lazy"
          alt="GirlDog"
          width={600}
          className="relative z-20 -mb-[148px] h-auto w-auto sm:mx-auto sm:pt-[15px] md:mx-0 md:-ml-[62px] lg:max-w-[600px] lg:pt-[55px]"
        />
      </div>
    </div>
  );
};

export default SectionDalmatian;
